import { numberMoney } from 'Data/format.js'

export function getAmount(item) {
  return numberMoney(
    Math.abs(item.entries.reduce((acc, entry) => acc + entry.amount, 0))
  )
}

export function getDescription(item) {
  return item.entries
    .map(
      entry =>
        `${getAdjustmentName(entry)} (${numberMoney(Math.abs(entry.amount))})`
    )
    .join(' + ')
}

function getAdjustmentName(transaction) {
  switch (transaction.dtype) {
    case 'FixAdjustment':
      return 'Fix Adjustment'
    case 'MigrationFixAdjustment':
      return 'Migration Fix'
    default:
      return transaction.dtype
  }
}
